import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PerfectButtonHoverVariants,
  PerfectButtonSize,
  PerfectButtonVariants,
} from '../../../../components/Common/Buttons/perfect-base-button/perfect-base-button.enums';
import STRING_KEYS from '../../../../language/keys';
import {
  Badge,
  BadgeIconWrapper,
  Container,
  IconContainer,
  InfoText,
  Subtitle,
  TopContainer,
  Title,
  BottomContainer,
  ActionButton,
  ActiveIndicationContainer,
  ActiveIndicationIcon,
} from './campaign-mode-button.styled';
import { CampaignModeButtonProps } from './campaign-mode-button';

const CampaignModeButton = ({
  title,
  subtitle,
  Icon,
  badgeText,
  BadgeIcon,
  isActive,
  isSelected,
  disabled,
  actionButtonConfig,
  infoText,
  clickHandler,
}: CampaignModeButtonProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const renderBadge = () => {
    if (!badgeText && !BadgeIcon) {
      return null;
    }

    return (
      <Badge disabled={ disabled }>
        { BadgeIcon && <BadgeIconWrapper disabled={ disabled }><BadgeIcon /></BadgeIconWrapper> }
        { badgeText }
      </Badge>
    );
  };

  const onActionButtonClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();

    if (actionButtonConfig?.clickHandler) {
      actionButtonConfig.clickHandler();
    } else {
      clickHandler?.();
    }
  };

  const renderBottomContainerContent = () => {
    if (isActive) {
      return (
        <ActiveIndicationContainer>
          <ActiveIndicationIcon />
          { translate(STRING_KEYS.CAMPAIGN_PAGE.MODES_SECTION.BUTTONS.ACTIVE_BUTTON_INDICATION) }
        </ActiveIndicationContainer>
      );
    }

    if (infoText) {
      return (<InfoText>{ infoText }</InfoText>);
    }

    if (actionButtonConfig) {
      return (
        <ActionButton
          onClick={ onActionButtonClick }
          size={ PerfectButtonSize.Medium }
          hoverVariant={ actionButtonConfig?.hoverVariant || PerfectButtonHoverVariants.NONE }
          variant={ PerfectButtonVariants.Fill }
          isLoading={ false }
          isCardDisabled={ disabled }
          Icon={ actionButtonConfig?.Icon }
          backgroundColor={ actionButtonConfig?.backgroundColor }
          color={ actionButtonConfig?.color }
          disabled={ isSelected }
          noPadding={ actionButtonConfig?.noPadding }
        >
          { actionButtonConfig.text }
        </ActionButton>
      );
    }

    return null;
  };

  return (
    <Container
      isSelected={ !!isSelected }
      disabled={ !!disabled }
      onClick={ () => clickHandler?.() }
    >
      <TopContainer>
        <IconContainer disabled={ disabled }><Icon /></IconContainer>
        <div>
          <Title disabled={ disabled }>{ title }</Title>
          <Subtitle disabled={ disabled }>{ subtitle }</Subtitle>
        </div>
      </TopContainer>
      <BottomContainer>
        { renderBottomContainerContent() }
      </BottomContainer>
      { renderBadge() }
    </Container>
  );
};

export default CampaignModeButton;
